<template>
    <div>
        <create-growth-phase-card />
        <growth-phase-list />
    </div>
</template>

<script>
import CreateGrowthPhaseCard from '../../components/culture-growth-phase/CreateGrowthPhaseCard'
import GrowthPhaseList from '../../components/culture-growth-phase/GrowthPhaseList'
import { mapState } from 'vuex'

export default {
    name: 'CultureGrowthPhaseView',
    components: {
        'create-growth-phase-card': CreateGrowthPhaseCard,
        'growth-phase-list': GrowthPhaseList,
    },
    computed: {
        ...mapState('auth', ['user']),
    },
    mounted() {
        if (!this.user || this.user.role !== 'super_admin') {
            return this.$router.push({ name: 'user-list' })
        }
    },
}
</script>

<style scoped>
</style>